<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Funding Details</h2>
    <v-divider></v-divider>
    <br />
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Funding ID :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.id }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Status :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            <h3>{{ loanStatus(loanDetails.loan_status_id) }}</h3>
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile v-if="loanDetails.loan_status_id == 8">
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Comment :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            <h3>{{ loanDetails.disburse_comment }}</h3>
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile v-if="loanDetails.loan_status_id == 8">
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Disbursement Date:</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.disbursed_at }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Loan Name :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.loan_product_title }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Application Time :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.created_at }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Amount :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.amount }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Duration :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.duration }}
            {{ loanDetails.duration == 1 ? "month" : "months" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Disbursed Amount :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.disbursed_amount }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Monthly Funding Due :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.monthly_funding_due }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Monthly Community Fee :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.monthly_community_fee }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Shadhin Onetime Fee :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.shadhin_one_time_fee }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Processing Fee :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.processing_fee }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Membership Welfare Fund :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content
            v-if="loanDetails.has_upfront_fee"
            :style="`color: ${
              loanDetails.is_upfront_fee_paid ? 'green' : 'red'
            }`"
          >
            <h4>
              {{ loanDetails.membership_welfare_fund }}
              {{ loanDetails.is_upfront_fee_paid ? " (Paid)" : " (Pending)" }}
            </h4>
          </v-list-tile-content>
          <v-list-tile-content v-else>
            {{ loanDetails.membership_welfare_fund }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Monthly Payment Gateway Fee :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.monthly_payment_gateway_fee }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Total Monthly Payable :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.total_monthly_payable }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Total Full Term Payable :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.total_full_term_payable }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Outstanding Loans :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.outstanding ? loanDetails.outstanding : 0 }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Loan Purpose :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{ loanDetails.loan_purpose }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
  </v-list>
</template>
<script>
  export default {
    props: ["loanDetails"],
    methods: {
      loanStatus(id) {
        switch (id) {
          case 1:
            return "Pending";
          case 2:
            return "Verified";
          case 3:
            return "Rejected";
          case 4:
            return "Processing";
          case 5:
            return "Signed by Investor";
          case 6:
            return "Signed by Investee";
          case 7:
            return "Approved";
          case 8:
            return "Disbursed";
          case 9:
            return "Completed";
          case 10:
            return "Cancelled";
          case 11:
            return "Defaulted";
          default:
            "Not specified";
        }
      },
    },
  };
</script>
